import { useContext } from 'react';

import AppContext from '@/contexts/appContext';
import { createRepository } from '@/repositories/GenericRepository';
import { ProgramQualification } from '@/types/person';
import { QueryParams } from '@/types/query';

const basePath = '/api/dugout/program_qualification';

export const programQualificationRepository = createRepository<
  ProgramQualification,
  ProgramQualification
>(basePath);

const ProgramQualificationRepository = () => {
  const { host } = useContext(AppContext);

  return {
    async list(params: QueryParams = {}) {
      return programQualificationRepository.list({ host, params });
    },

    async get({ id }: { id: string }) {
      return programQualificationRepository.get({ host, id });
    }
  };
};

export default ProgramQualificationRepository;
